// extracted by mini-css-extract-plugin
module.exports = {"fieldComposition":"_7DwVC","container":"Bta9u","title":"K2TNw","field":"_7rV5D","field_flex":"Vb3Qv"};